import userModule from './user';
import navigationModule from './navigation';
import validationModule from './validation';
import tasksModule from './tasks';
import alertsModule from './alerts';
import jobsModule from './jobs';
import notificationsModule from './notifications';

export default {
    user: userModule,
    navigation: navigationModule,
    validation: validationModule,
    notifications: notificationsModule,
    tasks: tasksModule,
    alerts: alertsModule,
    jobs: jobsModule
};